import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { RootState } from '../../store/store';
import { Button, Card, CardBody } from 'reactstrap';
import PasswordAppToken from './PasswordAppToken';
import { FlowSyncAccessPolicy, isAuthorized } from '../../models/FlowSyncAccessPolicy';
import PasswordChangeRoleSetting from './PasswordChangeRoleSetting';
import PasswordProfiles from './PasswordProfiles';



const PasswordConfiguration = () => {
    const { t } = useTranslation(['common']);

    const authorizedAccessPolicies = useSelector<RootState, FlowSyncAccessPolicy[]>(state => state.me.me?.authorizedAccessPolicies ?? []);
    const hasEditAppToken = isAuthorized(authorizedAccessPolicies, FlowSyncAccessPolicy.EDIT_APPTOKEN);
    const hasEditPasswordSettings = isAuthorized(authorizedAccessPolicies, FlowSyncAccessPolicy.EDIT_PASSWORD_SETTINGS);
    const [openToken, setOpenToken] = useState<boolean>(false);

    return (
    <Card className="padding-40 container single">
        <div className="flex justify-content-between align-items-baseline">
            <h1>{t('passwordSetting.title', { ns: 'common' })}</h1>
                <span title={!hasEditAppToken ? t('passwordTokens.editAppTokenPermission', { ns: 'common' }) : ""}>
                    <Button disabled={!hasEditAppToken} onClick={() => setOpenToken(true)}>{t('passwordTokens.title', { ns: 'common' })}</Button>
                </span>
        </div>
        <CardBody>
            <PasswordChangeRoleSetting disabled={!hasEditPasswordSettings} />
            <PasswordProfiles/> 
        </CardBody>

        {openToken && <PasswordAppToken
            isOpen={openToken}
            toggleModal={() => setOpenToken(false)}
        />}
    </Card>
    )
}

export default PasswordConfiguration;